import React from 'react';
import ReactDOM from 'react-dom';
import {ErrorBoundary} from '@dazn/lp-web/src/components/ErrorBoundary/ErrorBoundary';
import '@dazn/lp-web/src/fe-experiments/config';
import UnifiedLandingPageBase from '@dazn/lp-web/src/unified-landing-page';
import {LandingPageProvider} from '@dazn/lp-web/src/contexts/LandingPageContext';
import {FeLabelsProvider} from '@dazn/lp-web/src/contexts/FeLabelsContext';

export const UnifiedLandingPage: React.FC<{root: HTMLElement}> = ({root}) => {
    return (
        <ErrorBoundary>
            <FeLabelsProvider>
                <LandingPageProvider>
                    <UnifiedLandingPageBase root={root} />
                </LandingPageProvider>
            </FeLabelsProvider>
        </ErrorBoundary>
    );
};

export default function render(element: HTMLElement): void {
    document.body.classList.add('hideXScroll');
    ReactDOM.render(<UnifiedLandingPage root={element} />, element);
}
